import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Stack, Title } from "@mantine/core";
import { SvgIcon } from "@mui/material";
import { useEffect, useState } from "react";
import { ChipList } from "./ChipList";
export const ChipListCard = ({ icon, title, chips, highlights }) => {
    const [chipList, setChipList] = useState(chips || []);
    useEffect(() => {
        setChipList(chips || []);
    }, [chips]);
    return (_jsxs(Stack, { variant: "outline", style: { gap: 10 }, children: [_jsxs(Flex, { gap: "xs", align: "center", children: [_jsx(SvgIcon, { component: icon, style: {
                            width: "1rem",
                            color: "var(--mantine-color-gray-6)"
                        } }), _jsx(Title, { order: 5, children: title })] }), _jsx(ChipList, { chips: chipList, highlights: highlights })] }));
};
